import { formatMoney } from 'accounting'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp, faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, Link, Text,
} from '@domain-group/suit-theme'
import { useSetState } from '@domain-group/react-hooks'

import useOrderBundleItems from '@hooks/useOrderBundleItems'

import type { OrderBundleModel } from '@models/types'

import OrderBundleItem from '../OrderBundleItem'

type DefaultState = {
  expanded: boolean,
  loading: boolean,
}

export type SetState = (state: Partial<DefaultState>) => void

const defaultState = {
  expanded: false,
  loading: false,
}

interface OrderBundleProps {
  callbacks: {
    selectOrderBundle: (state: SetState) => void,
  },
  orderBundle: OrderBundleModel,
}

const OrderBundle = (props: OrderBundleProps) => {
  const {
    callbacks: {
      selectOrderBundle,
    },
    orderBundle: { id, price, title },
  } = props

  const [state, setState] = useSetState(defaultState)
  const { expanded, loading } = state

  const orderBundlesPayload = useOrderBundleItems({
    filters: {
      order_bundle_id: id,
    },
  })

  const {
    filteredOrderBundleItems,
    filteredOrderBundleItemsCount,
    hasFilteredOrderBundleItems,
  } = orderBundlesPayload

  return (
    <Box
      alignItems="center"
      border="1px dashed"
      borderColor="lineColor"
      borderRadius="5px"
      flexDirection="column"
      marginTop="medium"
      padding="large"
    >
      <Box>
        <Box justifyContent="center" flexDirection="column" width="calc(100% - 166px)">
          <Text fontSize="small" lineHeight="1.3">
            {title}
          </Text>

          <Link
            disabled={!hasFilteredOrderBundleItems}
            onClick={() => setState({ expanded: !expanded })}
            textProps={{ fontSize: 'small', marginTop: 'medium' }}
          >
            {hasFilteredOrderBundleItems && (
              <FontAwesomeIcon icon={expanded ? faAngleUp : faAngleDown} style={{ marginRight: 8 }} />
            )}

            {filteredOrderBundleItemsCount === 1 ? '1 Item' : `${filteredOrderBundleItemsCount} Items`}
          </Link>
        </Box>

        <Box alignItems="center" justifyContent="flex-end" marginLeft="auto" width={150}>
          <Text color="bodyFontLightColor" fontSize="small" marginRight="large">
            {formatMoney(price)}
          </Text>

          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            loading={loading}
            onClick={() => {
              setState({ loading: true })
              selectOrderBundle(setState)
            }}
            size="small"
            //@ts-expect-error
            width="auto"
          >
            Add
          </Button>
        </Box>
      </Box>

      {expanded && (
        <Box
          backgroundColor="whiteGrey"
          borderRadius="5px"
          flexDirection="column"
          marginTop="medium"
          padding="large"
          paddingTop="medium"
        >
          {filteredOrderBundleItems.map(orderBundleItem => (
            <OrderBundleItem key={orderBundleItem.id} orderBundleItem={orderBundleItem} />
          ))}
        </Box>
      )}
    </Box>
  )
}

export default OrderBundle
